import { apiOptions, apiRequest } from "../../utils";
import { API_V3 } from "../../constants";

export const cadBoundaryService = {
  getAll: async (params) => {
    const options = await apiOptions({
      url: `${API_V3}/cadBoundaries`,
      method: "get",
      params,
    });

    return apiRequest(options);
  },

  create: async (request) => {
    const options = await apiOptions({
      url: `${API_V3}/cadBoundaries`,
      method: "post",
      data: request,
    });

    return apiRequest(options);
  },

  update: async (id, request) => {
    const options = await apiOptions({
      url: `${API_V3}/cadBoundaries/${id}`,
      method: "put",
      data: request,
    });

    return apiRequest(options);
  },

  delete: async (id) => {
    const options = await apiOptions({
      url: `${API_V3}/cadBoundaries/${id}`,
      method: "delete",
    });

    return apiRequest(options);
  },

  getCadImage: async (params) => {
    const options = await apiOptions({
      url: `${API_V3}/cadImage/`,
      method: "get",
      params,
    });

    return apiRequest(options);
  },

  updateCadImage: async (request) => {
    const options = await apiOptions({
      url: `${API_V3}/cadImage`,
      method: "post",
      data: request,
    });

    return apiRequest(options);
  },
};
